import { render, staticRenderFns } from "./BasicCardHorizontal.vue?vue&type=template&id=e76d8f9a&"
import script from "./BasicCardHorizontal.vue?vue&type=script&lang=js&"
export * from "./BasicCardHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports